<template>
    <el-aside width="230px">
        <div class="app-info">
            <div class="ding" :class="getApp.appStatus != 1 ? '' : 'pub'"></div>
            <div class="published">{{filter.appStatus(getApp.appStatus)}}</div>
            <div class="app-img"><img :src="getApp.appIcon" alt=""></div>
            <div class="app-name">{{getApp.appName}}</div>
            <div class="app-type">应用类型：{{filter.appType(getApp.appType)}}</div>
        </div>
        <el-menu 
            :default-active="defaultActive" 
            text-color="#666" 
            :router="true"
            active-text-color="#000">
            <el-menu-item index='param'>
                <i></i>
                <span>应用参数</span>
            </el-menu-item>
            <el-menu-item index='page'>
                <i></i>
                <span>页面设置</span>
            </el-menu-item>
            <el-menu-item index='pay'>
                <i></i>
                <span>支付设置</span>
            </el-menu-item>
            <el-menu-item index='records' v-show="getApp.appStatus == 1">
                <i></i>
                <span>授权站点</span>
                <sup class="badge" v-if="data">{{data}}</sup>
            </el-menu-item>
            <el-menu-item index='authorize' v-show="getApp.appStatus != 1">
                <i></i>
                <span>授权站点</span>
            </el-menu-item>
        </el-menu>
    </el-aside>
</template>
<script>
import {filter, http, apiJson} from "@/utils/http"
export default {
    data () {
        return {
            getApp: {}
        }
    },
    created () {
        this.filter = filter
        this.getListApps()
        this.countUnreadApply()
    },
    updated () {
        if(this.reload) {
            this.$emit('changeReload')
            this.getListApps()
        }
    },
    props: ['reload'],
    methods: {
        getListApps () {
            http(apiJson.listApps).then(res => {
                if(res) {
                    if(res.code == 0) {
                        let {params} = this.$route
                        res.data.map(item => {
                            if(item.appId == params.id) {
                                this.getApp = item
                            }
                        })
                        
                    }else if(res.code == 2) {
                        Message.warning(res.message)
                    }else {
                        Message.error('接口错误:' + res.message)
                        this.$router.push("/login")
                    }
                }else {
                    Message.error('接口错误')
                    this.$router.push("/login")
                }
            }).catch(error => {
                console.log(error)
            })
        },
        countUnreadApply () {
            let {params} = this.$route
            http(`${apiJson.countUnreadApply}/${params.id}`).then(res => {
                if(res.code == 0) {
                    this.$store.dispatch('changeDataNum',res.data)
                }
            })
        }
    },
    computed: {
        defaultActive () {
            return this.$store.state.default_active 
        },
        data () {
            return this.$store.state.data
        }
    }
}
</script>
<style lang='scss' scope>
    @import './scss/left-aside.scss';
</style>





// WEBPACK FOOTER //
// src/components/left-aside.vue